import { ILinkData } from '@msdyn365-commerce/core';
import { observable, reaction, when } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IWineClub } from '../../../settings/app.settings';
import { CartUtilities } from '../../../Utilities/cart-utils';

import { CartVerifier } from '../../cartmanager/cart-verified';
import { WineClubDataRef, WineClubDataStore } from '../wine-club-data';
import { IWineClubSignupData } from '../wine-club-signup.data';
import { IWineClubSignupProps } from '../wine-club-signup.props.autogenerated';

export interface ISignup {
    wineCheckout?: ILinkData;
    props: IWineClubSignupProps<IWineClubSignupData>;
}

/**
 * renders the sign up button with its appropriate conditions
 */
@observer
export class Signup extends React.Component<ISignup> {

    private _wineClubDataStore: WineClubDataStore;

    @observable private _allowSignup: boolean = false;
    @observable private _cartVerified: boolean = false;
    public constructor(props: ISignup) {
        super(props);

        this._proceedToCheckout = this._proceedToCheckout.bind(this);

        this._wineClubDataStore = WineClubDataStore.getInstance((change) => {
            this._allowSignup = this._allowSignupLogic(change);
        });

        this._allowSignup = this._allowSignupLogic(this._wineClubDataStore.get());

        reaction(
            () => [CartVerifier.instance, CartVerifier.instance.isVerified],
            () => {
                this._cartVerified = CartVerifier.instance.isVerified;
            }
        );
    }

    public componentDidMount(): void {
        console.log('this.props.props.context.request.query;', this.props.props.context.request.query);
        if (CartVerifier.instance.isVerified !== this._cartVerified) {
            this._cartVerified = CartVerifier.instance.isVerified;
        }
    }

    public render(): JSX.Element {
        return (
            <div className='wine-club-signup-signup'>
                <button className='wine-club-signup-signup-button' disabled={!this._allowSignup} onClick={this._proceedToCheckout}>
                    {this.props.props.resources.wineClubSignup__signup}
                </button>
            </div>
        );
    }

    private async _proceedToCheckout(): Promise<void> {
        this._allowSignup = false;
        // we might want to add error handling here at some point
        await this._addItem().catch(e => this._allowSignup = true); // attempt item add, only works with none in cart
        when(
            () => {
                const length = this.props.props.data.cart.result?.cart.CartLines?.length || 0;
                return length > 0;
            },
            () => {
                this._allowSignup = true;
                const refId = sessionStorage.getItem('refId');
                // tslint:disable-next-line: no-typeof-undefined
                if (this.props.wineCheckout?.destinationUrl && typeof window !== 'undefined') {
                    let destinationUrl = this.props.wineCheckout.destinationUrl;
                    if(refId && refId !== '') {
                        destinationUrl = destinationUrl.includes('?') ? `${destinationUrl}&refId=${refId}`: `${destinationUrl}?refId=${refId}`;
                    }
                    window.location.href = destinationUrl;
                }
            }
        );
    }

    /**
     * logic for signing up
     *
     * @param store contextual wine club info
     * @returns true if allow, false if no
     */
    private _allowSignupLogic(store: WineClubDataRef): boolean {
        return store.clubId !== null &&
            store.variantPreference !== null &&
            store.tosAgree;
    }

    private async _addItem(): Promise<void> {
        const loadedCart = await this.props.props.data.cart;
        if (loadedCart.cart.CartLines?.length === 0) {
            const itemId = this._getClubItemId();
            await CartUtilities.addItem({
                recordId: +itemId,
                context: this.props.props.context,
                amount: 1
            }, true); // disable OOS because digital
        }
    }

    private _getClubItemId(): string {
        const wineClubs = this.props.props.app.config.wineClubSetup as IWineClub[] || [];
        const store = WineClubDataStore.getInstance().get();
        const club = wineClubs[store.clubId!];
        if (!club) {
            return '';
        }
        const variants = club.variants || [];
        const variant = variants.find(cVariant => cVariant.winePreference === store.variantPreference);

        if (!variant) { return ''; }
        return variant.itemId;
    }
}